/*
 * Meetketen voor de offerteaanvraag op de relatiegeschenken-pagina.
 *
 * Dit bestand telt een geslaagde offerteaanvraag als conversie. Het staat los van
 * relatiegeschenken.js, want dat bestand rekent en mag daar niet door verstoord
 * raken, en het wordt met een eigen script (workflows/relatiegeschenken/meetketen.py)
 * op het thema gezet en er weer af gehaald. Er staat geen zichtbare tekst in, dus er
 * valt niets aan te vertalen.
 *
 * WAT HET MEET. Een relatiegeschenken-order loopt via mail en telefoon en niet via de
 * kassa. Er is dus geen bestelling waaraan een advertentieklik te koppelen valt. Het
 * enige harde succes-signaal is de terugkeer op de pagina met ?contact_posted=true,
 * de redirect die Shopify doet na een geslaagde {% form 'contact' %}-inzending.
 *
 * VIER DINGEN MAKEN DAT LASTIGER DAN HET LIJKT. Alle vier zijn gemeten op 31 augustus
 * en 1 september 2026, zie workflows/relatiegeschenken/onderzoek/01-meetbaarheid.md.
 *
 *  1. Zes formulieren in het thema delen dezelfde parameter: relatiegeschenken,
 *     zakelijk, tastings, contact-form, b2b-login en business-gift-form. Een trigger
 *     op alleen ?contact_posted=true telt dus aanvragen van vijf andere pagina's mee.
 *     Daarom filtert dit bestand ook op het pad, en wel op alle vijf de taal-slugs.
 *  2. De parameter is te herhalen. Een verversing, de terugknop of een geplakte URL
 *     rendert het bedankblok opnieuw zonder dat er ooit is gePOST. Daarom telt er hier
 *     alleen iets als we het indienen zelf hebben gezien: bij submit gaat er een
 *     briefje in sessionStorage, en dat briefje wordt bij het vuren meteen opgegeten.
 *     Geen briefje is geen conversie. Dat is strenger dan een simpel eenmalig-slot en
 *     het is met opzet zo: liever een gemiste telling dan een geplakte URL die telt.
 *  3. Na de redirect is het formulier leeg opnieuw gerenderd. Het e-mailadres en de
 *     berekende contact[richtprijs_ex_btw] zijn op dat moment weg. Daarom staan ze op
 *     hetzelfde briefje: zo krijgt de conversie een waarde in euro's en kan enhanced
 *     conversions het gehashte e-mailadres meesturen.
 *  4. Een GTM-container in het custom-pixel-iframe (GTM-5R5P5GMC) dupliceert elke
 *     paginalading in GA4. Drie echte inzendingen leverden zes GA4-hits met de
 *     parameter. Dit bestand stuurt daarom een eigen gebeurtenis vanuit het
 *     hoofdvenster in plaats van te leunen op een paginalading-conditie. Dat iframe
 *     abonneert alleen op de standaard Shopify-events en ziet een eigen gtag-event
 *     nooit, dus dubbeltellen kan langs deze weg niet.
 *
 * HOE HET VERSTUURT. window.gtag draait op elke storefront-pagina, want de Google &
 * YouTube-webpixel (2495775068) draait in runtimeContext OPEN, dus in het hoofdvenster
 * en niet in een iframe. AW-721096472 staat als gekoppelde bestemming in de
 * gtag.js-payload van G-BXP5JCHTVL. Een gtag('event', 'conversion', { send_to:
 * 'AW-721096472/<label>' }) routeert daardoor zonder dat dit bestand zelf een tag laadt.
 *
 * WAT ER NOG MOET GEBEUREN VOORDAT ER IETS TELT. CONVERSIELABEL hieronder is leeg.
 * Die vult zich pas als de conversieactie "Verzending leadformulier" in Google Ads
 * bestaat; zie MEETKETEN-GOOGLE-ADS-GA4.md in de workflow-map. Zolang het label leeg
 * is doet dit bestand alles behalve de Ads-conversie: het briefje, het slot, de
 * GA4-gebeurtenis en het storefront-event lopen wel, en er komt een regel in de console.
 */
(function () {
  'use strict';

  var CONFIG = {
    /* Leeg tot de conversieactie in Google Ads bestaat. Formaat: 'AW-721096472/AbCdEfGh1jK'.
       Het conversie-ID van dit account is 721096472 (gemeten, conversion_tracking_setting). */
    CONVERSIELABEL: 'AW-721096472/RjniCLbBzKIdEJie7NcC',

    /* De Ads-bestemming. Alleen gebruikt voor de config-aanroep hieronder. */
    ADS_ID: 'AW-721096472',

    /* De naam van de GA4-gebeurtenis. generate_lead is de standaardnaam van Google
       voor precies dit moment en is in deze property nog niet in gebruik, dus hij
       botst met niets. Markeer hem in GA4 als sleutelgebeurtenis. */
    GA4_EVENT: 'generate_lead',

    /* De vijf taal-slugs van de pagina, gemeten op 31 augustus 2026 (alle vijf HTTP 200).
       Zonder deze lijst tellen de vijf andere contactformulieren van de winkel mee. */
    SLUGS: [
      'champagne-relatiegeschenken',
      'champagner-firmengeschenke',
      'cadeaux-d-affaires-au-champagne',
      'champagne-business-gifts',
      'regali-aziendali-di-champagne'
    ],

    /* false = alleen tellen als we het indienen zelf hebben gezien. Zie punt 2 boven.
       Op true telt een geplakte of ververste URL ook mee, zonder waarde. Niet doen
       zolang het volume zo laag is dat één valse telling het beeld kantelt. */
    VUUR_ZONDER_STASH: false,

    /* Enhanced conversions: het gehashte e-mailadres meesturen. Dit zet ook de
       config-aanroep op AW-721096472 aan, want zonder die aanroep kan er op die
       bestemming geen allow_enhanced_conversions staan. Die aanroep is tegelijk de
       eerste diagnose als een echte inzending niet in Google Ads opduikt. */
    ENHANCED: true,

    /* Een eigen storefront-event publiceren, zodat er later een Custom Pixel op kan
       abonneren voor het Meta Lead-event. Vandaag abonneert er niets op en gebeurt er
       dus niets; de aanroep is dan een lege huls en kost niets. */
    PUBLICEER_STOREFRONT_EVENT: true,

    /* Hoe lang we wachten tot de Google-tag echt geladen is, en met welke stap. */
    WACHT_MS: 8000,
    STAP_MS: 200,

    /* Een briefje ouder dan dit is niet meer van deze aanvraag. Dat kan gebeuren als
       de POST door recaptcha of een netwerkfout nooit is aangekomen. */
    BRIEFJE_MAX_MIN: 30,

    /* Zet op true om in de console te volgen wat er gebeurt. */
    PRAAT: false
  };

  var BRIEFJE = 'rg-lead';
  var SLOT = 'rg-lead-gevuurd';

  function praat(bericht, extra) {
    if (!CONFIG.PRAAT || !window.console || !window.console.log) return;
    window.console.log('[rg-meting] ' + bericht, extra === undefined ? '' : extra);
  }

  /* ---------------------------------------------------------------- opslag */

  /* sessionStorage kan in een afgeschermde browser gooien in plaats van null te
     geven. Elke aanraking zit daarom in een try. Valt de opslag weg, dan telt er
     niets meer, en dat is de goede kant om te falen. */
  function lees(sleutel) {
    try {
      return window.sessionStorage.getItem(sleutel);
    } catch (e) {
      return null;
    }
  }

  function schrijf(sleutel, waarde) {
    try {
      window.sessionStorage.setItem(sleutel, waarde);
      return true;
    } catch (e) {
      return false;
    }
  }

  function wis(sleutel) {
    try {
      window.sessionStorage.removeItem(sleutel);
    } catch (e) {
      /* niets te doen */
    }
  }

  /* ------------------------------------------------------------ hulpstukken */

  function opOnzePagina() {
    var pad = String(window.location.pathname || '').replace(/\/+$/, '');
    for (var i = 0; i < CONFIG.SLUGS.length; i += 1) {
      /* Op het laatste padstuk vergelijken en niet op het hele pad, want elke taal
         heeft er een eigen prefix voor staan (/de/pages/..., /fr/pages/... enzovoort). */
      if (pad === '/' + CONFIG.SLUGS[i] || pad.slice(-(CONFIG.SLUGS[i].length + 1)) === '/' + CONFIG.SLUGS[i]) {
        return true;
      }
    }
    return false;
  }

  function isBedankt() {
    try {
      return new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    } catch (e) {
      return /[?&]contact_posted=true(&|$)/.test(String(window.location.search || ''));
    }
  }

  function kenmerk() {
    /* Eén kenmerk met drie taken: sleutel van het briefje, slot tegen dubbel vuren,
       en transaction_id op de conversie zodat Google zelf ook nog kan ontdubbelen. */
    var willekeur = Math.random().toString(36).slice(2, 10);
    return 'rg-' + Date.now().toString(36) + '-' + willekeur;
  }

  function veldwaarde(kiezer) {
    var el = document.querySelector(kiezer);
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function sha256(tekst) {
    var crypto = window.crypto || window.msCrypto;
    if (!crypto || !crypto.subtle || typeof window.TextEncoder !== 'function') {
      return Promise.resolve(null);
    }
    try {
      return crypto.subtle.digest('SHA-256', new window.TextEncoder().encode(tekst))
        .then(function (buffer) {
          var bytes = new window.Uint8Array(buffer);
          var uit = '';
          for (var i = 0; i < bytes.length; i += 1) {
            uit += ('0' + bytes[i].toString(16)).slice(-2);
          }
          return uit;
        })
        .catch(function () {
          return null;
        });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  /* --------------------------------------------------------- het indienen */

  function hangSubmitOp() {
    var form = document.getElementById('rg-offerte-form') || document.querySelector('form.rg-form');
    if (!form || form.dataset.rgMeting === 'ja') return;
    form.dataset.rgMeting = 'ja';

    form.addEventListener('submit', function () {
      /* Het briefje wordt hier geschreven en nergens anders. Het e-mailadres staat er
         onversleuteld op, precies één navigatie lang en alleen in het tabblad van de
         bezoeker zelf; op de bedankt-lading wordt het gehasht en meteen gewist. Het
         adres gaat nooit de dataLayer of de GA4-parameters in, alleen de hash. */
      var mail = veldwaarde('#rg-offerte-form input[name="contact[email]"]')
        || veldwaarde('form.rg-form input[name="contact[email]"]');
      var briefje = {
        kenmerk: kenmerk(),
        mail: mail ? mail.toLowerCase() : '',
        waarde: veldwaarde('[data-rg-prijsveld]'),
        aantal: veldwaarde('[data-rg-aantalveld]'),
        taal: document.documentElement.getAttribute('lang') || '',
        tijd: Date.now()
      };
      try {
        schrijf(BRIEFJE, JSON.stringify(briefje));
        praat('briefje geschreven', briefje.kenmerk);
      } catch (e) {
        /* JSON.stringify kan hier niet stuk, maar de opslag wel; dan telt het niet. */
      }
    });
  }

  /* ------------------------------------------------------------- het vuren */

  function haalBriefje() {
    var rauw = lees(BRIEFJE);
    wis(BRIEFJE);
    if (!rauw) return null;
    var briefje;
    try {
      briefje = JSON.parse(rauw);
    } catch (e) {
      return null;
    }
    if (!briefje || typeof briefje !== 'object') return null;
    var oud = Date.now() - (Number(briefje.tijd) || 0);
    if (oud > CONFIG.BRIEFJE_MAX_MIN * 60 * 1000) {
      praat('briefje te oud, genegeerd');
      return null;
    }
    return briefje;
  }

  function wachtOpGoogleTag(klaar) {
    var begin = Date.now();
    (function tik() {
      var gereed = false;
      try {
        /* Niet toetsen of window.gtag bestaat, want dat is ook waar als alleen de
           wachtrij-stub er staat. google_tag_manager krijgt pas een sleutel als
           gtag.js echt een bestemming heeft ingericht. */
        var gtm = window.google_tag_manager;
        gereed = !!gtm && Object.keys(gtm).length > 0;
      } catch (e) {
        gereed = false;
      }
      if (gereed) return klaar(true);
      if (Date.now() - begin >= CONFIG.WACHT_MS) return klaar(false);
      window.setTimeout(tik, CONFIG.STAP_MS);
    }());
  }

  function gtag() {
    /* Precies het patroon dat de Google & YouTube-webpixel zelf ook gebruikt, met
       dezelfde ||-vangnetten, zodat wie het eerst is wint en de wachtrij gedeeld
       blijft. dataLayer.push krijgt het arguments-object en geen array; gtag.js
       rekent daarop. */
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }
    window.gtag.apply(null, arguments);
  }

  function stuur(briefje, hash) {
    var kenmerkNu = (briefje && briefje.kenmerk) || kenmerk();

    var bedrag = null;
    if (briefje && briefje.waarde) {
      var g = parseFloat(String(briefje.waarde).replace(',', '.'));
      /* Het veld is leeg zolang de bezoeker niets heeft aangeklikt. Dan gaat er geen
         value mee, en zeker geen nul: een conversie van nul euro trekt het gemiddelde
         omlaag en suggereert een aanvraag zonder waarde. */
      if (isFinite(g) && g > 0) bedrag = Math.round(g * 100) / 100;
    }

    if (CONFIG.ENHANCED) {
      /* Zonder een eigen config op de Ads-bestemming kan allow_enhanced_conversions
         daar niet staan. Deze aanroep is onschadelijk naast de webpixel, en hij is
         tegelijk de eerste diagnose als een echte inzending niet aankomt. */
      gtag('config', CONFIG.ADS_ID, { allow_enhanced_conversions: true });
      if (hash) {
        gtag('set', 'user_data', { sha256_email_address: hash });
      }
    }

    if (CONFIG.CONVERSIELABEL) {
      var ads = {
        send_to: CONFIG.CONVERSIELABEL,
        transaction_id: kenmerkNu
      };
      if (bedrag !== null) {
        ads.value = bedrag;
        ads.currency = 'EUR';
      }
      gtag('event', 'conversion', ads);
      praat('Ads-conversie verstuurd', ads);
    } else if (window.console && window.console.warn) {
      window.console.warn('[rg-meting] geen CONVERSIELABEL ingevuld, de Google '
        + 'Ads-conversie is overgeslagen. Zie MEETKETEN-GOOGLE-ADS-GA4.md.');
    }

    var ga4 = {
      /* Alleen herkomst en omvang, geen persoonsgegevens. */
      aanvraag_bron: 'relatiegeschenken',
      aanvraag_taal: briefje && briefje.taal ? briefje.taal : '',
      aanvraag_aantal: briefje && briefje.aantal ? briefje.aantal : '',
      transaction_id: kenmerkNu
    };
    if (bedrag !== null) {
      /* Ex btw, net als alles op deze pagina. Leg dat vast in GA4 bij de gebeurtenis,
         anders legt iemand dit bedrag straks naast een orderbedrag inclusief btw. */
      ga4.value = bedrag;
      ga4.currency = 'EUR';
    }
    gtag('event', CONFIG.GA4_EVENT, ga4);
    praat('GA4-gebeurtenis verstuurd', ga4);

    if (CONFIG.PUBLICEER_STOREFRONT_EVENT) {
      try {
        if (window.Shopify && window.Shopify.analytics
            && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('offerte_aangevraagd', {
            waarde: bedrag,
            aantal: ga4.aanvraag_aantal,
            taal: ga4.aanvraag_taal,
            kenmerk: kenmerkNu
          });
        }
      } catch (e) {
        /* Een web pixel die stukgaat mag deze pagina niet meeslepen. */
      }
    }
  }

  function misschienVuren() {
    if (!isBedankt()) return;

    /* Het briefje wordt meteen gelezen en gewist, nog voor er iets async gebeurt.
       Twee ladingen vlak na elkaar kunnen zo niet allebei hetzelfde briefje pakken. */
    var briefje = haalBriefje();
    if (!briefje && !CONFIG.VUUR_ZONDER_STASH) {
      praat('geen briefje, dus geen conversie (verversing, terugknop of geplakte URL)');
      return;
    }

    if (lees(SLOT)) {
      praat('slot staat dicht, er is in deze sessie al geteld');
      return;
    }
    /* Het slot gaat dicht vóór het wachten op de Google-tag. Een verversing tijdens
       dat wachten telt dan niet alsnog mee. Komt de tag niet, dan is de telling weg;
       dat is de prijs, en ONE_PER_CLICK in Google Ads vangt de andere kant af. */
    schrijf(SLOT, (briefje && briefje.kenmerk) || 'zonder-briefje');

    var mail = briefje && briefje.mail ? String(briefje.mail).trim().toLowerCase() : '';
    var hashKlaar = (CONFIG.ENHANCED && mail) ? sha256(mail) : Promise.resolve(null);

    hashKlaar.then(function (hash) {
      wachtOpGoogleTag(function (gereed) {
        if (!gereed && window.console && window.console.warn) {
          window.console.warn('[rg-meting] de Google-tag was na '
            + CONFIG.WACHT_MS + ' ms nog niet ingericht; de gebeurtenis gaat toch de '
            + 'wachtrij in.');
        }
        stuur(briefje, hash);
      });
    }).catch(function () {
      wachtOpGoogleTag(function () {
        stuur(briefje, null);
      });
    });
  }

  /* ---------------------------------------------------------------- starten */

  function start() {
    if (!opOnzePagina()) {
      /* Ook de voorbeeldweergave /pages/zakelijk?view=relatiegeschenken valt hier af.
         Dat is expres: een proef op de voorbeeld-URL hoort niet mee te tellen. */
      praat('niet op een van de vijf slugs, dit bestand doet niets');
      return;
    }
    hangSubmitOp();
    misschienVuren();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* De thema-editor hangt de sectie opnieuw in de pagina bij elke wijziging; dan moet
     de submit-listener er opnieuw op. Vuren gebeurt daar niet, want het slot staat
     dicht en er is geen briefje. */
  document.addEventListener('shopify:section:load', function () {
    if (opOnzePagina()) hangSubmitOp();
  });

  /* Voor de node-test in workflows/relatiegeschenken/. In de browser bestaat
     module niet en gebeurt hier niets. */
  if (typeof module === 'object' && module.exports) {
    module.exports = {
      CONFIG: CONFIG,
      start: start,
      opOnzePagina: opOnzePagina,
      isBedankt: isBedankt,
      haalBriefje: haalBriefje
    };
  }
}());
